// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/area.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bfftypes/v1/area.proto.
 */
export const file_bfftypes_v1_area: GenFile = /*@__PURE__*/
  fileDesc("ChZiZmZ0eXBlcy92MS9hcmVhLnByb3RvEgtiZmZ0eXBlcy52MSJBCgpBcmVhT3B0aW9uEiQKBXZhbHVlGAEgASgOMhUuYmZmdHlwZXMudjEuQXJlYUNvZGUSDQoFbGFiZWwYAiABKAkqZQoIQXJlYVR5cGUSGQoVQVJFQV9UWVBFX1VOU1BFQ0lGSUVEEAASEwoPQVJFQV9UWVBFX1RPS1lPEAESFAoQQVJFQV9UWVBFX0tBTlNBSRACEhMKD0FSRUFfVFlQRV9DSFVCVRADKu8BCghBcmVhQ29kZRIZChVBUkVBX0NPREVfVU5TUEVDSUZJRUQQABIWChJBUkVBX0NPREVfSE9LS0FJRE8QARIUChBBUkVBX0NPREVfVE9IT0tVEAISEwoPQVJFQV9DT0RFX1RPS1lPEAMSEwoPQVJFQV9DT0RFX0NIVUJVEAQSFgoSQVJFQV9DT0RFX0hPS1VSSUtVEAUSFAoQQVJFQV9DT0RFX0tBTlNBSRAGEhUKEUFSRUFfQ09ERV9DSFVHT0tVEAcSFQoRQVJFQV9DT0RFX1NISUtPS1UQCBIUChBBUkVBX0NPREVfS1lVU0hVEAlCsAEKD2NvbS5iZmZ0eXBlcy52MUIJQXJlYVByb3RvUAFaRWdpdGh1Yi5jb20vZW5lY2hhaW4vZXBvc2l0aW9uLWFwcC9iYWNrZW5kL2dlbi9wcm90by9iZmZ0eXBlcy92MTt0eXBlc6ICA0JYWKoCC0JmZnR5cGVzLlYxygILQmZmdHlwZXNcVjHiAhdCZmZ0eXBlc1xWMVxHUEJNZXRhZGF0YeoCDEJmZnR5cGVzOjpWMWIGcHJvdG8z");

/**
 * @generated from message bfftypes.v1.AreaOption
 */
export type AreaOption = Message<"bfftypes.v1.AreaOption"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode value = 1;
   */
  value: AreaCode;

  /**
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message bfftypes.v1.AreaOption.
 * Use `create(AreaOptionSchema)` to create a new message.
 */
export const AreaOptionSchema: GenMessage<AreaOption> = /*@__PURE__*/
  messageDesc(file_bfftypes_v1_area, 0);

/**
 * @generated from enum bfftypes.v1.AreaType
 */
export enum AreaType {
  /**
   * 未指定
   *
   * @generated from enum value: AREA_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 東京
   *
   * @generated from enum value: AREA_TYPE_TOKYO = 1;
   */
  TOKYO = 1,

  /**
   * 関西
   *
   * @generated from enum value: AREA_TYPE_KANSAI = 2;
   */
  KANSAI = 2,

  /**
   * 中部
   *
   * @generated from enum value: AREA_TYPE_CHUBU = 3;
   */
  CHUBU = 3,
}

/**
 * Describes the enum bfftypes.v1.AreaType.
 */
export const AreaTypeSchema: GenEnum<AreaType> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_area, 0);

/**
 * @generated from enum bfftypes.v1.AreaCode
 */
export enum AreaCode {
  /**
   * @generated from enum value: AREA_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 北海道
   *
   * @generated from enum value: AREA_CODE_HOKKAIDO = 1;
   */
  HOKKAIDO = 1,

  /**
   * 東北
   *
   * @generated from enum value: AREA_CODE_TOHOKU = 2;
   */
  TOHOKU = 2,

  /**
   * 東京
   *
   * @generated from enum value: AREA_CODE_TOKYO = 3;
   */
  TOKYO = 3,

  /**
   * 中部
   *
   * @generated from enum value: AREA_CODE_CHUBU = 4;
   */
  CHUBU = 4,

  /**
   * 北陸
   *
   * @generated from enum value: AREA_CODE_HOKURIKU = 5;
   */
  HOKURIKU = 5,

  /**
   * 関西
   *
   * @generated from enum value: AREA_CODE_KANSAI = 6;
   */
  KANSAI = 6,

  /**
   * 中国
   *
   * @generated from enum value: AREA_CODE_CHUGOKU = 7;
   */
  CHUGOKU = 7,

  /**
   * 四国
   *
   * @generated from enum value: AREA_CODE_SHIKOKU = 8;
   */
  SHIKOKU = 8,

  /**
   * 九州
   *
   * @generated from enum value: AREA_CODE_KYUSHU = 9;
   */
  KYUSHU = 9,
}

/**
 * Describes the enum bfftypes.v1.AreaCode.
 */
export const AreaCodeSchema: GenEnum<AreaCode> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_area, 1);

